import React, {useState} from 'react'
import Uppy from '@uppy/core'
import ImageEditor from '@uppy/image-editor'
import XHRUpload from '@uppy/xhr-upload'
import {DashboardModal} from '@uppy/react'
import {useDispatch} from 'react-redux'

import * as auth from '../../modules/auth/redux/AuthRedux'

import '@uppy/core/dist/style.min.css'
import '@uppy/dashboard/dist/style.min.css'
import '@uppy/image-editor/dist/style.min.css'

import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {USER_SET_PIC} from '../_CRUD'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {UserModel} from '../../modules/auth/models/UserModel'

// @ts-ignore
import de_DE from '@uppy/locales/lib/de_DE'
// @ts-ignore
import en_US from '@uppy/locales/lib/en_US'

export const AvatarPicker = ({user}: {user?: UserModel}) => {
  const language = useLang()
  const dispatch = useDispatch()
  const [modalShow, toggleModal] = useState(false)

  const [uppy] = useState(() => {
    const instance = new Uppy({
      meta: {type: 'avatar'},
      restrictions: {
        maxNumberOfFiles: 1,
      },
      locale: language === 'de' ? de_DE : en_US,
    })

    instance.use(ImageEditor, {
      id: 'ImageEditor',
      quality: 0.8,
      cropperOptions: {
        background: true,
        autoCrop: true,
        autoCropArea: 1,
        responsive: true,
        aspectRatio: 1,
        croppedCanvasOptions: {},
      },
      actions: {
        revert: true,
        rotate: true,
        granularRotate: true,
        flip: true,
        zoomIn: true,
        zoomOut: true,
        cropSquare: false,
        cropWidescreen: false,
        cropWidescreenVertical: false,
      },
    })

    instance.use(XHRUpload, {
      endpoint: USER_SET_PIC,
      formData: true,
      fieldName: 'pic',
    })

    instance.on('error', (error) => {
      console.error(error)
    })

    instance.on('complete', (result) => {
      const file = result.successful?.[0]

      if (file?.response?.body) {
        const url = file.response.body

        dispatch(
          auth.actions.setUser({
            ...user,
            pic: url as any,
          })
        )
      }
    })

    return instance
  })

  return (
    <div>
      <div
        className='image-input image-input-outline'
        data-kt-image-input='true'
        style={{
          backgroundImage: `url(${toAbsoluteUrl('/media/avatars/blank.png')})`,
        }}
      >
        <div
          className='image-input-wrapper w-125px h-125px'
          style={{
            backgroundImage: `url(${
              user?.pic ? toAbsoluteUrl(user.pic) : toAbsoluteUrl('/media/avatars/blank.png')
            })`,
            cursor: 'pointer',
          }}
          onClick={() => toggleModal(true)}
        />
      </div>

      <DashboardModal
        uppy={uppy}
        plugins={['ImageEditor']}
        open={modalShow}
        onRequestClose={() => toggleModal(false)}
        locale={{
          strings: {
            poweredBy: '',
          },
        }}
      />
    </div>
  )
}
